// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__sGjY+","footerTitle":"Footer_footerTitle__njKre","footerLink":"Footer_footerLink__StoHe"};